import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let medical_forms = useDataValue({
    context: 'medical_forms',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!medical_forms?.length) return data

    return {
      id: medical_forms[0].id,
      name: `${medical_forms[0].name}-${
        medical_forms[0].last_modified_by === 'None' ||
        medical_forms[0].last_modified_by === undefined ||
        medical_forms[0].last_modified_by === null
          ? 'New Form'
          : medical_forms[0].last_modified_by
      }`,
      categories: medical_forms[0].categories,
    }
  }, [data, medical_forms])
}
